import {
  AlertTriangle,
  Clock,
  ShieldAlert,
  UserRound,
  Wrench,
} from "lucide-react";

const cards = [
  ["Activity Today", "today", Clock],
  ["This Week", "this_week", Wrench],
  ["Warnings", "warnings", AlertTriangle],
  ["Critical Events", "danger", ShieldAlert],
  ["Staff Actions", "recent_staff_actions", UserRound],
];

export default function ActivitySummaryCards({ summary }) {
  return (
    <div className="activity-summary-grid">
      {cards.map(([title, key, Icon]) => (
        <article className="activity-summary-card" key={key}>
          <Icon size={18} />
          <span>{title}</span>
          <strong>{summary?.[key] || 0}</strong>
        </article>
      ))}
    </div>
  );
}